import { AppNav as UIAppNav, type AppNavProps as UIAppNavProps } from "@qw/ui";

import { usePage } from "@/providers/use-page";

export type AppNavProps = Omit<UIAppNavProps, "isCollapsed" | "setIsCollapsed">;

export const AppNav = ({ side = "left", ...props }: AppNavProps) => {
  const { isLeftNavCollapsed, setIsLeftNavCollapsed, isRightNavCollapsed, setIsRightNavCollapsed } = usePage();
  const isCollapsed = side === "right" ? isRightNavCollapsed : isLeftNavCollapsed;
  const setIsCollapsed = side === "right" ? setIsRightNavCollapsed : setIsLeftNavCollapsed;

  return <UIAppNav {...props} side={side} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />;
};
